/**
 * W8 PR-2 — Faction-Color Boss Burst FX 顏色對照表。
 *
 * spec 路徑:`docs/game-pr-specs/W8-boss-polish.md` §3.3。
 *
 * 用途:`HorizontalBattleScene._emitBossBurst(factionId, x, y)` 在 boss 死亡
 * 爆炸 burst 階段讀取此 table,選用對應門派色作 `JuiceLayer.flashSprite`
 * 共鳴 + Phaser Graphics 圓圈漸層光暈。讓 5 門派 boss 死亡視覺有識別性
 * (取代既有通用黃 burst)。
 *
 * 規則:
 *   - key 對應 `BossDef.faction` 字串。
 *   - value 為 24-bit RGB hex number(直接餵 Phaser GameObjects.Graphics
 *     `fillStyle(color, alpha)` / JuiceLayer.flashSprite color 參數)。
 *   - 未知 faction 由呼叫端走 fallback `0xffd54f`(通用金 — 與 W5 既有
 *     yellow/orange explosion mix 風格一致)。
 *
 * 為何分檔(不直接 inline 進 scene):
 *   - PR-1(`feature/game-w8-pr1-faction-ai`)與 PR-2 file-disjoint;
 *     PR-1 改 `_bossDefeated`/`tickAttacks`,PR-2 只新增此檔 +
 *     `_emitBossBurst` private method。table 抽檔避免 scene 內常數區搶 git
 *     diff 行,降低 merge conflict 機率。
 *   - 後續若 ResultScene(PR-3)需 mastery box 升級動畫共用門派色,
 *     可直接 import 此 table,不必複製 5 行 mapping。
 */
export const FACTION_BURST_COLOR: Record<string, number> = {
  /** 星算門(數獸) — 紫 */
  celestial: 0x9c27b0,
  /** 符文門(字靈) — 藍 */
  runic: 0x1565c0,
  /** 機械門(語靈) — 綠 */
  techno: 0x2e7d32,
  /** 自然門(元獸) — 金 */
  elemental: 0xf9a825,
  /** 疆域門(域靈) — 紅 */
  dominion: 0xc62828,
};

/** Fallback 通用色 — 與 W5 既有 boss explosion yellow/orange 風格對齊。 */
export const FACTION_BURST_FALLBACK_COLOR: number = 0xffd54f;
